// src/api/BrokerRegistration.js
import api from "./axiosConfig";

// Fetch all broker registration types
export const getBrokerRegistration = async () => {
  try {
    const res = await api.get("BRegistration/brokerregistration/");
    // backend returns an array with one main object
    return res.data[0];
  } catch (error) {
    console.error("Error fetching Broker Registration data:", error);
    return null;
  }
};


export const getBR2Data = async () => {
  try {
    const res = await api.get("BRegistration/br2/");
    return res.data[0]; // assuming backend returns an array with a single object
  } catch (error) {
    console.error("Failed to fetch BR2 data:", error);
    return null;
  }
};


export const getBR3 = async () => {
  try {
    const res = await api.get("BRegistration/br3/");
    return res.data[0]; // backend returns an array, we take the first object
  } catch (error) {
    console.error("Failed to fetch BR3 data:", error);
    return null;
  }
};